import React, { createContext, useState, useEffect, useContext } from 'react';
import { checkAuth, logout as logoutService } from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    verifyAuth();
  }, []);

  const verifyAuth = async () => {
    try {
      const authData = await checkAuth();

      if (authData.isAuthenticated && authData.user) {
        setIsAuthenticated(true);
        setUserInfo(authData.user);
      } else {
        setIsAuthenticated(false);
        setUserInfo(null);
      }
    } catch (error) {
      setIsAuthenticated(false);
      setUserInfo(null);
    } finally {
      setIsLoading(false);
    }
  };

  const logout = async () => {
    await logoutService();

    setIsAuthenticated(false);
    setUserInfo(null);
    window.location.replace('/login');
  };

  const revalidate = () => {
    setIsLoading(true);
    verifyAuth();
  };

  const value = {
    isAuthenticated,
    isLoading,
    userInfo,
    logout,
    revalidate
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  return context;
};

export default AuthContext;

